import React from "react";

const Mission = () => {
  return (
    <div>
      <div className="bg-gray-300 py-16 w-full mx-auto rounded-sm shadow-2xl">
        <h1 className="text-4xl mt-6 flex items-center justify-center font-bold text-black mb-4">
          OUR VISION
        </h1>
        <span className="flex m-5 text-1xl w-3/4 lg:w-2/4 mx-auto leading-relaxed font-semibold items-center text-gray-700 justify-center md:w-3/4">
          <br />
          <p className="italic text-center">
            "To be the chosen Service Partner/Vendor for all Telecom, Power{" "}
            <br />& Energy, Civil Infrastructure & Construction Projects."
          </p>
        </span>
      </div>
      <div className="bg-white py-16">
        <h1 className="text-4xl mt-6 flex items-center justify-center font-bold text-black mb-4">
          OUR MISSION
        </h1>
        <span className="flex m-5 text-1xl w-3/4 lg:w-2/4 mx-auto leading-relaxed font-semibold items-center text-gray-700 justify-center md:w-3/4">
          <br />
          <p className="italic text-center">
            "To deliver high-quality, cost effective projects on schedule by
            employing and focussed team. We value the importance of our
            relationship and will continue to remain fair and true in our
            dealing with all employees, clients, vendors & partners. Our client
            count on our dependability, drive and integrity. We take great pride
            in our accomplishment and build on them every day."
          </p>
        </span>
      </div>
    </div>
  );
};

export default Mission;
